/**
 * English Translations (Nested Object Structure)
 * For KinKen Kost Elite international visitors
 */

import { Translations } from "./id";

const translations: Translations = {
  nav: {
    home: "Home",
    rooms: "Rooms & Suites",
    facilities: "Facilities",
    gallery: "Gallery",
    about: "About KinKen",
    location: "Location & Map",
    faq: "FAQ Center",
    contact: "Contact Us",
    testimonials: "Testimonials",
    career: "Career",
    bookNow: "Book Now",
    exploreMore: "Explore More",
    followUs: "Follow KinKen",
    bookSanctuary: "Book Your Sanctuary",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    sitemap: "Sitemap",
  },
  hero: {
    superText: "Luxury Living Redefined",
    title: "Live in",
    titleHighlight: "Luxury",
    subtitle: "KinKen Kost Elite brings a new standard of premium living in Bali. The first kost concept with 24/7 concierge service, architect-curated interior design, and 5-star hotel-grade amenities.",
    cta: {
      explore: "Explore Residences",
      tour: "Schedule a Tour",
    },
    scrollText: "Discover Your Luxury",
  },
  about: {
    tagline: "About KinKen",
    title: "More Than Just a Place to Stay",
    description: "KinKen Kost Elite was created for those who demand more than just a room. We bring the philosophy of 'luxury co-living' that combines personal privacy with an exclusive community.",
    cta: "Our Full Story",
  },
  rooms: {
    flexiStay: "Flexi-Stay Available",
    title: "Experience KinKen Living",
    subtitle: "From overnight stays to extended living, each room is a sanctuary designed for the modern professional. Experience hotel-grade luxury with the privacy of your own space.",
    viewDetails: "View Details",
    more: "+More",
    daily: "Daily Rate",
    monthly: "Monthly",
    bestValue: "Best Value",
    mostPopular: "Most Popular",
    exploreAll: "Explore All Rooms",
  },
  facilities: {
    tagline: "World Class Amenities",
    title: "Premium Facilities\nUp to 5-Star Hotel Standard.",
    subtitle: "Every facility at KinKen is designed to support the modern urban lifestyle. From productivity to relaxation, we've thought of everything.",
    exploreAll: "Explore All Facilities",
  },
  gallery: {
    tagline: "The KinKen Experience",
    title: "Luxury in Every Frame.",
    subtitle: "A visual journey through KinKen's premium spaces. Each photo captures the perfect details of an elite residence designed to indulge the senses and bring tranquility.",
    exploreAll: "Explore Full Gallery",
  },
  testimonials: {
    title: "Voices of Excellence",
    subtitle: "Join our global community of residents who have made KinKen their sanctuary in Bali. Discover why we're consistently rated as the best luxury co-living experience in Bali.",
  },
  faq: {
    tagline: "FAQ CENTER",
    title: "Frequently Asked Questions",
    subtitle: "Answers to common questions from our prospective residents. Everything you need to know about the luxury living experience at KinKen.",
    badge: "5-star amenities included",
    exploreAll: "Explore All FAQs",
  },
  contact: {
    tagline: "PREMIUM CONCIERGE",
    title: "Personalized Service",
    description: "Our 24/7 concierge team is ready to assist with booking inquiries, virtual tours, or personalized consultation for your luxury living needs in Bali.",
    detailsButton: "Contact & Location Details",
    fastResponse: "Fast Response Guarantee",
    formTagline: "INQUIRY FORM",
    formTitle: "Send Us a Message",
    formSubtitle: "Fill out the form below for a personalized response from our team. We will contact you within 15 minutes.",
    nameLabel: "Full Name",
    subjectLabel: "Subject",
    messageLabel: "Your Message",
    messagePlaceholder: "Please provide details about your inquiry, preferred check-in dates, and any specific requirements...",
    sendButton: "Send Message to Concierge",
    sendButtonShort: "Send Message",
    processing: "Processing",
    disclaimer: "By submitting, you agree to our privacy policy. Response time: 15 minutes during business hours.",
    subjects: [
      "Room Availability Information",
      "Private Viewing / Virtual Tour",
      "Long-stay Rates & Special Packages",
      "Corporate Partnership",
      "Facilities & Amenities Questions",
      "General Information / Others",
    ],
  },
  common: {
    learnMore: "Learn More",
    viewAll: "View All",
    backToHome: "Back to Home",
    loading: "Loading...",
    error: "An error occurred",
    tryAgain: "Try Again",
    close: "Close",
    open: "Open",
    language: "Language",
  },
};

export default translations;
